<!-- eslint-disable vue/no-bare-strings-in-template -->
<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import SettingsSection from 'dashboard/components/SettingsSection.vue';
const formatsToRemove = ['DOCUMENT', 'IMAGE', 'VIDEO'];

export default {
  components: {
    SettingsSection,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedTemplates: [],
      templates: [],
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  watch: {
    inbox() {
      this.loadTemplates();
    },
  },
  mounted() {
    this.loadTemplates();
  },
  methods: {
    loadTemplates() {
      const templates = this.$store.getters['inboxes/getWhatsAppTemplates'](
        this.inbox.id
      )
        .filter(template => template.status.toLowerCase() === 'approved')
        .filter(template => {
          return template.components.every(component => {
            return !formatsToRemove.includes(component.format);
          });
        });
      this.templates = templates.map(template => ({
        ...template,
        selected: template.selected || false,
      }));
      this.selectedTemplates = this.templates
        .filter(template => template.selected)
        .map(template => template.id);
    },
    toggleTemplateSelection(templateId) {
      const template = this.templates.find(t => t.id === templateId);
      if (template) {
        template.selected = !template.selected;
        this.selectedTemplates = this.templates
          .filter(t => t.selected)
          .map(t => t.id);
      }
    },
    toggleAllTemplatesSelection() {
      const allSelected = this.templates.every(template => template.selected);
      this.templates.forEach(template => {
        template.selected = !allSelected;
      });
      this.selectedTemplates = this.templates
        .filter(template => template.selected)
        .map(template => template.id);
    },
    getTemplatebody(template) {
      return template.components.find(component => component.type === 'BODY')
        .text;
    },
    async updateTemplates() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {},
        };

        payload.channel.message_templates_selected = this.selectedTemplates;

        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert('Templates atualizados com sucesso!');
      } catch (error) {
        useAlert(error.message || 'Erro ao atualizar os templates.');
      }
    },
  },
};
</script>

<template>
  <div class="mx-8">
    <SettingsSection
      title="Selecione quais os templates deseja que o time de atendimento utilize"
      sub-title="Templates são formas padronizadas de entrar em contato com o cliente. Ao desmarcar um template ele não ficará visivel para que o time de atendimento use durante uma conversa."
    >
      <form @submit.prevent="updateTemplates">
        <table class="w-full border-collapse">
          <thead>
            <tr>
              <th class="text-left px-4 py-2 checkbox-label">
                <input
                  type="checkbox"
                  :checked="selectedTemplates.length === templates.length"
                  @change="toggleAllTemplatesSelection"
                />
                <span class="template-name"> Template </span>
              </th>
              <th class="text-left px-4 py-2">
                {{ $t('WHATSAPP_TEMPLATES.PICKER.LABELS.TEMPLATE_BODY') }}
              </th>
              <th class="text-left px-4 py-2">
                {{ $t('WHATSAPP_TEMPLATES.PICKER.LABELS.CATEGORY') }}
              </th>
              <th class="text-left px-4 py-2">
                {{ $t('WHATSAPP_TEMPLATES.PICKER.LABELS.LANGUAGE') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="template in templates"
              :key="template.id"
              class="border-t"
            >
              <td class="px-4 py-2 checkbox-label">
                <input
                  type="checkbox"
                  :checked="template.selected"
                  @change="toggleTemplateSelection(template.id)"
                />
                <span class="template-name">
                  {{ template.name }}
                </span>
              </td>
              <td class="px-4 py-2">
                {{ getTemplatebody(template) }}
              </td>
              <td class="px-4 py-2">
                {{ template.category }}
              </td>
              <td class="px-4 py-2">
                {{ template.language }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="mt-4">
          <woot-submit-button
            button-text="Atualizar Templates da caixa de entrada"
            :loading="uiFlags.isUpdating"
          />
        </div>
      </form>
    </SettingsSection>
  </div>
</template>

<style lang="scss" scoped>
.table-container {
  @apply w-full overflow-x-auto;
}

table {
  @apply w-full border-collapse;
}

th {
  @apply text-left px-4 py-3 text-sm font-medium;
}

td {
  @apply px-4 py-3 text-sm;
}

.checkbox-label {
  @apply flex items-center space-x-2;
}

.template-name {
  @apply ml-[5px];
}

.submit-button-container {
  @apply mt-6 flex justify-start;
}
</style>
